// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__N3yZl","footerPadding":"footer_footerPadding__TUZS0","footerNav":"footer_footerNav__NgiAH"};